import { Component } from '@angular/core';

@Component({
	selector: 'app-loader',
	template: `<div class="module-loader">
		<div class="spinner spinner-bubble spinner-bubble-primary mr-3"></div>
	</div>`
})
export class LoaderComponent {}
